import { RouterView } from "vue-router";
import { ETAB_ROUTES } from "@etab/config";

import getDetailPages from "./detail";
import getCandidatePages from "./candidate";
import getActivationPages from "./activation";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.temporary.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.temporary.root.name,
      component: RouterView,
      children: [
        ...getDetailPages(), //
        ...getCandidatePages(),
        ...getActivationPages(),
      ],
    },
  ];
}
